// extracted by mini-css-extract-plugin
module.exports = {"Connect":"ConnectTerminalDialog_Connect__1BTQ5","NotConnected":"ConnectTerminalDialog_NotConnected__1zk8L","Disabled":"ConnectTerminalDialog_Disabled__1s2tY"};